export default __webpack_public_path__ + "f188ce0f3c3beb3248d1410ed582856e.woff2";